export default {
  name: 'Techniciens',
  cardView: {
    nodata: "(Impossible de localiser l'installation)",
    planif: {
      end: 'Terminée',
      in_progress: 'En cours',
      scheduled: 'Prévue la semaine du ',
    },
    roles: {
      mdi_account_alert: 'Technicien en charge',
      mdi_account_clock: "Technicien d'astreinte",
      mdi_account_cowboy_hat: 'Responsable de maintenance',
      mdi_account_question: 'Technicien de recours',
      mdi_account_switch_outline: 'Binôme',
    },
    status: {
      end: 'Intervention terminée',
      in_progress: 'En intervention',
      scheduled: 'Intervention planifiée',
    },
    switch: {
      error: "Impossible de localiser l'installation, données indisponibles",
      list: 'Basculer sur la vue liste',
      map: 'Basculer sur la vue carte',
      refresh: 'Vue par défaut',
      title: 'Vue carte',
    },
  },
  noItems:
    "Pas de résultats en relation avec l'organisation et les filtres sélectionnés",
  search: 'Rechercher',
  assign: 'Affecter',
  assigned: 'Affecté',
  tech_interventions: 'Interventions du technicien',
  property_interventions: "Interventions sur l'installation",
  no_data_in_progress: 'Aucune intervention en cours',
  no_data_scheduled: 'Aucune intervention à venir',
  fields: {
    employee_id: 'Matricule',
    scheduled: 'Ordo',
    nav_full_id: 'Organisation',
    notScheduled: 'Non Ordo',
    position: 'Fonction',
    full_name: 'Nom',
    entity_id: 'Code EPEX',
    entity_name: 'EPEX',
    entity_nav_full_id: 'EPEX',
    company_subcontractor_name: 'Entreprise',
    activity_field: "Domaine d'activité",
    phone: 'Moyen de communication',
    phone_type: 'Type de téléphone',
    role: 'Rôle',
    roles: 'Rôles',
    event_datetime: "Dans moins d'1h | Dans 1h | Dans {n}h",
    event_datetime_expired: "Il y a moins d'1h | Il y a 1h | Il y a {n}h",
    absence: 'Absence',
    techStatus: 'Actuellement',
  },
  transmit: 'Transmettre',
  cancel: 'Annuler',
  close: 'Fermer',
  type: 'Type',
  affected_tech: 'Technicien affecté',
  affected_tech_message: 'Vous avez affecté une demande à :',
  transmit_question: 'Voulez-vous transmettre ?',
  transmit_success: 'La demande a été transmise avec succès à',
  already_transmitted: 'La demande a déjà été transmise.',
  comment_too_long:
    'Ce commentaire est trop long pour être transmis merci de le réduire (1023 car max)',
  positions: {
    on_call: 'Astreinte',
    on_call_end: 'FIN Astreinte',
  },
};
